import { Controller } from "@hotwired/stimulus";
import ApexCharts from "apexcharts";

export default class extends Controller {
  static values = {
    series: Array,
    categories: Array,
  }
  connect() {
    var options = {
      series: this.seriesValue,
      chart: {
        type: "line",
        height: 342,
        toolbar: {
          show: false
        },
        dropShadow: {
          enabled: true,
          enabledOnSeries: undefined,
          top: 7,
          left: 0,
          blur: 1,
          color: ["rgba(var(--primary-rgb))", "rgba(var(--primary-rgb), 0.2)", "rgb(255, 90, 41)"],
          opacity: 0.05,
        },
      },
      colors: [
        "rgba(var(--primary-rgb))",
        "rgba(var(--primary-rgb), 0.2)", "rgb(255, 90, 41)"
      ],
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: true,
        position: "top",
        offsetX: 0,
        offsetY: 8,
        markers: {
          size: 4,
          strokeWidth: 0,
          strokeColor: '#fff',
          fillColors: undefined,
          radius: 12,
          customHTML: undefined,
          onClick: undefined,
          offsetX: 0,
          offsetY: 0
        },
      },
      stroke: {
        curve: 'smooth',
        width: [1.5, 1.5, 1.5],
        lineCap: 'round',
        dashArray: [0, 4, 0],
      },
      fill: {
        type: ['gradient', 'solid'],
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.4,
          opacityTo: 0.1,
          stops: [0, 90, 100],
          colorStops: [
            [
              {
                offset: 0,
                color: "rgba(var(--primary-rgb), 0.1)",
                opacity: 0.1
              },
              {
                offset: 75,
                color: "rgba(var(--primary-rgb), 0.1)",
                opacity: 1
              },
              {
                offset: 100,
                color: 'rgba(var(--primary-rgb), 0.2)',
                opacity: 1
              }
            ],
            [
              {
                offset: 0,
                color: 'rgb(255, 90, 41)',
                opacity: 1
              },
              {
                offset: 75,
                color: 'rgb(255, 90, 41)',
                opacity: 1
              },
              {
                offset: 100,
                color: 'rgb(255, 90, 41)',
                opacity: 1
              }
            ],
          ]
        }
      },
      grid: {
        borderColor: "#f1f1f1",
        strokeDashArray: 2,
        xaxis: {
          lines: {
            show: true
          }
        },
        yaxis: {
          lines: {
            show: false
          }
        }
      },
      yaxis: {
        show: false,
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        }
      },
      xaxis: {
        categories: this.categoriesValue,
        show: false,
        axisBorder: {
          show: false,
          color: 'rgba(119, 119, 142, 0.05)',
          offsetX: 0,
          offsetY: 0,
        },
        axisTicks: {
          show: false,
          borderType: 'solid',
          color: 'rgba(119, 119, 142, 0.05)',
          width: 6,
          offsetX: 0,
          offsetY: 0
        },
        labels: {
          rotate: -90,
        }
      },
    };
    var chart4 = new ApexCharts(this.element, options);
    chart4.render();
  }
}
